import { render } from "./customerManage.vue?vue&type=template&id=30dad2e2"
import script from "./customerManage.vue?vue&type=script&lang=js"
export * from "./customerManage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__